import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ExhibitDashboardComponent } from './exhibits/exhibit-dashboard/exhibit-dashboard.component';
import { VisitorLogComponent } from './exhibits/exhibit-dashboard/visitor-log/visitor-log.component';
import { ExhibitVideoModalComponent } from './exhibits/public/exhibit-video-modal.component';
import { ExhibitorBoothComponent } from './exhibits/public/exhibitor-booth.component';
import { ExhibitMaterialsComponent } from './exhibits/public/materials/exhibit-materials.component';
import { IsAuthenticatedGuard } from './_guards/isAuthenticated.gaurd';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';

@NgModule({
  declarations:[
    ExhibitorBoothComponent,
    ExhibitDashboardComponent,
    ExhibitMaterialsComponent,
    VisitorLogComponent,
    ExhibitVideoModalComponent
  ],
  entryComponents:[
    ExhibitVideoModalComponent,
  ],
  imports:[
    NgbModalModule,
    ApplicationPipesModule,
    RouterModule.forChild([
      { path: ':id', component: ExhibitorBoothComponent,  data: { preview: false, title:'View Exhibit' }  },
      { path: ':id/preview', component: ExhibitorBoothComponent, data: { preview: true, title:'Preview Exhibit' } },
      { path: ':id/dashboard', component: ExhibitDashboardComponent, data: { title: "Exhibit Dashboard"} },
    ])
    ],
  exports:[]
})
export class ExhibitsModule{}
